<template>
	<div class="password-change__form form">
		<div class="form__inputs form__inputs--2">
			<InputText :label="'Пароль'" :placeholder="'Введите пароль'" :password="true" v-model="formData.password" :errors="v$.formData.password.$errors" />
			<InputText :label="'Повторите пароль'" :placeholder="'Введите пароль повторно'" :password="true" v-model="formData.confirmation" :errors="v$.formData.confirmation.$errors"/>
		</div>
		<div class="form__submit">
			<button class="form__submit-btn btn btn--color" @click.prevent="sendForm">Изменить пароль</button>		</div>
	</div>
</template>


<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import Fetch from "@/utils/Fetch";
import useVuelidate from "@vuelidate/core";
import objectToFormData from "@/utils/ObjectToFormData";
import {helpers, minLength, required} from '@vuelidate/validators'
import { useToast } from "vue-toastification";
const {withMessage} = helpers

const checkMatch  = (formData) => () => {
	if(formData.password === formData.confirmation) {
		return true
	}
	return false
}


export default {
	name: "ChangePassword",
	components: {InputText},
	props: {
		email: {
			type: String,
			default: ''
		},
		checkword: {
			type: String,
			default: ''
		},
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				password: '',
				confirmation: ''
			}
		}
	},
	methods: {
		async sendForm() {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}

			const body = objectToFormData({
				email: this.email,
				checkword: this.checkword,
				password: this.formData.password,
				confirmation: this.formData.confirmation,
			})

			let response = await Fetch('user/password-change/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success('Ваш пароль успешно изменен');
				window.location.href = '/personal/'
			} else {
				this.toast.error(response.message);
			}
		},
	},
	validations() {
		return {
			formData: {
				password: {
					required: withMessage("Заполните пароль", required),
					minLength: withMessage("Минимальная длина пароля 6 символов", minLength(6)),
				},
				confirmation: {
					required: withMessage("Заполните пароль", required),
					minLength: withMessage("Минимальная длина пароля 6 символов", minLength(6)),
					checkMatch: withMessage('Подтверждение пароля должно совпадать', checkMatch(this.formData))
				}
			}
		}
	},
}

</script>
